import React from 'react';
import { Admin, Resource, type ResourceOptions, LoginWithEmail } from "react-admin";
import { i18nProvider } from '../../i18nProvider';

// PLG Imagenes Inicio
import PLGImagenesInicioList from './plg-imagenes-inicio/PLGImagenesInicioList';
import PLGImagenesInicioCreate from './plg-imagenes-inicio/PLGImagenesInicioCreate';
import PLGImagenesInicioEdit from './plg-imagenes-inicio/PLGImagenesInicioEdit';

// PLG Tarjetas Inicio
import PLGTarjetasInicioList from './plg-tarjetas-inicio/TarjetasInicioList';
import PLGTarjetasInicioCreate from './plg-tarjetas-inicio/TarjetasInicioCreate';
import PLGTarjetasInicioEdit from './plg-tarjetas-inicio/TarjetasInicioEdit';

// PLG Quienes Somos
import QuienesSomosList from './plg-quienes-somos/QuienesSomosList';
import QuienesSomosCreate from './plg-quienes-somos/QuienesSomosCreate';
import QuienesSomosEdit from './plg-quienes-somos/QuienesSomosEdit';

// PLG Proyectos
import ProyectosList from './plg-proyecto/ProyectosList';
import ProyectosCreate from './plg-proyecto/ProyectosCreate';
import ProyectosEdit from './plg-proyecto/ProyectosEdit';

// PLG Nuestra Historia
import NuestraHistoriaList from './plg-nuestra-historia/NuestraHistoriaList';
import NuestraHistoriaCreate from './plg-nuestra-historia/NuestraHistoriaCreate';
import NuestraHistoriaEdit from './plg-nuestra-historia/NuestraHistoriaEdit';

// PLG Casa Abierta
import CasaAbiertaList from './plg-casa-abierta/CasaAbiertaList';
import CasaAbiertaCreate from './plg-casa-abierta/CasaAbiertaCreate';
import CasaAbiertaEdit from './plg-casa-abierta/CasaAbiertaEdit';

// PLG Nuestro Parque
import NuestroParqueList from './plg-nuestro-parque/NuestroParqueList';
import NuestroParqueCreate from './plg-nuestro-parque/NuestroParqueCreate';
import NuestroParqueEdit from './plg-nuestro-parque/NuestroParqueEdit';

// PLG Noticias
import NoticiasList from './plg-noticias/NoticiasList';
import NoticiasCreate from './plg-noticias/NoticiasCreate';
import NoticiasEdit from './plg-noticias/NoticiasEdit';

// Iconos
import CollectionsIcon from '@mui/icons-material/Collections';
import StyleIcon from '@mui/icons-material/Style';
import GroupsIcon from '@mui/icons-material/Groups';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import ParkIcon from '@mui/icons-material/Park';
import HistoryIcon from '@mui/icons-material/History';
import NewspaperIcon from '@mui/icons-material/Newspaper';

import { customDataProvider, customAuthProvider } from '../../config/services/strapi/provider';

function App() {

  return (
    <Admin
      basename='/admin'
      dataProvider={customDataProvider}
      authProvider={customAuthProvider}
      loginPage={LoginWithEmail}
      i18nProvider={i18nProvider}
    >
      <Resource
        name="plg-imagenes-inicios"
        list={PLGImagenesInicioList}
        create={PLGImagenesInicioCreate}
        edit={PLGImagenesInicioEdit}
        options={{
          label: 'PLG Imágenes Inicio',
        } as ResourceOptions}
        icon={CollectionsIcon}
      />

      <Resource
        name="plg-tarjetas-inicios"
        list={PLGTarjetasInicioList}
        create={PLGTarjetasInicioCreate}
        edit={PLGTarjetasInicioEdit}
        options={{
          label: 'PLG Tarjetas Inicio',
        } as ResourceOptions}
        icon={StyleIcon}
      />

      <Resource
        name="plg-quienes-somoss"
        list={QuienesSomosList}
        create={QuienesSomosCreate}
        edit={QuienesSomosEdit}
        options={{
          label: 'PLG Quienes Somos',
        } as ResourceOptions}
        icon={GroupsIcon}
      />

      <Resource
        name="plg-proyectoss"
        list={ProyectosList}
        create={ProyectosCreate}
        edit={ProyectosEdit}
        options={{
          label: 'PLG Proyectos',
        } as ResourceOptions}
        icon={BusinessCenterIcon}
      />

      <Resource
        name="plg-nuestra-historias"
        list={NuestraHistoriaList}
        create={NuestraHistoriaCreate}
        edit={NuestraHistoriaEdit}
        options={{
          label: 'PLG Nuestra Historia',
        } as ResourceOptions}
        icon={HistoryIcon}
      />

      <Resource
        name="plg-casa-abiertas"
        list={CasaAbiertaList}
        create={CasaAbiertaCreate}
        edit={CasaAbiertaEdit}
        options={{
          label: 'PLG Casa Abierta',
        } as ResourceOptions}
        icon={MeetingRoomIcon}
      />

      <Resource
        name="plg-nuestro-parques"
        list={NuestroParqueList}
        create={NuestroParqueCreate}
        edit={NuestroParqueEdit}
        options={{
          label: 'PLG Nuestro Parque',
        } as ResourceOptions}
        icon={ParkIcon}
      />

      <Resource
        name="plg-noticiass"
        list={NoticiasList}
        create={NoticiasCreate}
        edit={NoticiasEdit}
        options={{
          label: 'PLG Noticias',
        } as ResourceOptions}
        icon={NewspaperIcon}
      />

    </Admin>
  );
}

export default App;